import { render, staticRenderFns } from "./viewProposals.vue?vue&type=template&id=7245f991&scoped=true&"
import script from "./viewProposals.vue?vue&type=script&lang=js&"
export * from "./viewProposals.vue?vue&type=script&lang=js&"
import style0 from "./viewProposals.vue?vue&type=style&index=0&lang=css&"
import style1 from "./viewProposals.vue?vue&type=style&index=1&id=7245f991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245f991",
  null
  
)

export default component.exports